import { render, staticRenderFns } from "./RelatedApproval.vue?vue&type=template&id=6ee5e1a1"
import script from "./RelatedApproval.vue?vue&type=script&lang=js"
export * from "./RelatedApproval.vue?vue&type=script&lang=js"
import style0 from "./RelatedApproval.vue?vue&type=style&index=0&id=6ee5e1a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports